import { useEffect, useState } from "react";
import { AxiosError } from "axios";
import { ITicketsAuto } from "../../../../../interfaces";
import { EmitError } from "../../../../../utils/EmitError";
import TicketsAutoService from "../../../../../services/http/services/TicketsAutoService";

interface IProps {
    id?: number | string;
    giveawayId?: number | string;
}

export default function useModalGiveawayTicketsAuto({ id, giveawayId }: IProps) {
    const [tickets, setTickets] = useState<Array<ITicketsAuto>>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        if (!id || !giveawayId) {
            setTickets([]);
            return;
        }

        const controller = new AbortController();

        async function loadTickets() {
            try {
                setIsLoading(true);
                const data = await TicketsAutoService.listTicketsByGiveawayIdAndAppUserId(
                    Number(giveawayId),
                    Number(id),
                    controller.signal
                );
                setTickets(data);
                setIsLoading(false);
            } catch (err) {
                if (err instanceof AxiosError && err.name === 'CanceledError') {
                    return;
                }
                EmitError(err, true, 'modalGiveawayTicketsAuto_loadError');
                setIsLoading(false);
            }
        }

        loadTickets();

        return () => {
            controller.abort();
        };
    }, [id, giveawayId]);

    return {
        tickets,
        isLoading,
    };
}
